import { Controller } from "stimulus"
// import Velocity from "velocity-animate"

export default class extends Controller {
  static targets = [ "item" ]

  connect() {
  }

  toggle() {
    var item = this.itemTarget;
    var button = event.target;
    if (item.classList.contains('is-expanded')) {
      var slideDir = 'slideUp';
      item.classList.remove("is-expanded");
      button.textContent = button.dataset.expandText;
    } else {
      var slideDir = 'slideDown';
      item.classList.add("is-expanded");
      button.textContent = button.dataset.collapseText;
    }

    Velocity(item, slideDir, {duration: 200, easing: 'ease-in-out' })
  }
}
